import { useCallback, useState } from 'react';
import { FlexRow } from './account-settings-tab';
import { Spinner, Switch, Title } from '@restworld/ui-ds';
import 'twin.macro';
import { useAuth } from '@restworld/feature-authentication';
import { useWorkersService } from '@restworld/data-services';
import { setWorkerAtom, workerAtom } from '../../profile/global-state';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';

const showProposedJobApplicationsAtom = atom((get) => {
  const worker = get(workerAtom);
  return worker?.data?.proposal_notifications_enabled;
});

export const ProposedJobPositionSetting = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const onSetWorkerData = useSetAtom(setWorkerAtom);
  const { t } = useTranslation('user-settings');
  const auth = useAuth();
  const workerService = useWorkersService();
  const showProposedJobApplications = useAtomValue(showProposedJobApplicationsAtom);

  const onSetEnabled = useCallback(
    async (enabled: boolean) => {
      setIsLoading(true);
      const response = await workerService.updateWorker({
        workerId: auth.user?.id,
        params: {
          proposal_notifications_enabled: enabled,
        },
      });
      onSetWorkerData({ ...response.data });
      setIsLoading(false);
    },
    [auth.user?.id, onSetWorkerData, workerService]
  );
  return (
    <FlexRow tw="gap-8 justify-between items-start w-full">
      <Title fontWeight="semibold" textColor="black" standardVariant="h5">
        {t('notification_tab_proposed_job_settings_header')}
      </Title>
      <div tw="inline-flex gap-2 items-center justify-end w-[100px] min-w-[100px]">
        <Switch
          enabled={showProposedJobApplications}
          onChange={onSetEnabled}
          srOnlyLabel={t('notification_tab_switch_label')}
        />
        {isLoading && <Spinner color="primary" size="sm" />}
      </div>
    </FlexRow>
  );
};
